<template>
  <div style="    background: rgb(249, 250, 254);">
    <nav_list></nav_list>

    <div class="per">

      <div class="t1">
        <div class="tit1">

          {{$lang(42340)}}

        </div>
        <div class="img1">
          <img :src="thumb ? thumb : '~@/../static/image/cover1.png'" alt="">
        </div>
        <div class="train">
          <span class="tit2">{{ $lang(42341)}} </span>
          <div class="con1">
            <span>{{ info.trainv.strs.sn }} </span>
          </div>
        </div>
        <div class="txt1" v-if="cp_info">
          <div class="text1">
            <span v-html="cp_info"> </span>
          </div>
        </div>

      </div>


      <div class="t2">
        <div class="step1">
          <div class="con1">
            <img src="~@/../static/image/step2.png" alt="">
            <div class="y1">
              <span class="u1">{{ $lang(42342)}}</span><br>
              <span class="u2">{{ $lang(42343)}}</span>
            </div>
          </div>
          <div class="con1">

            <img src="~@/../static/image/ok.png" alt="">
            <div class="y1">
              <span class="u1">{{ $lang(42344)}}</span><br>
              <span class="u2">{{ $lang(42345)}}</span>
            </div>
          </div>
          <div class="con1">
            <img src="~@/../static/image/step3.png" alt="">
            <div class="y1">
              <span class="u1">{{ $lang(42346)}}</span><br>
              <span class="u2">{{ $lang(42347)}}</span>
            </div>
          </div>
        </div>

        <div class="channel">
          <div style="margin-left: 2%;">
            {{info.trainv.strs.title}}
          </div>
          <div class="screen">
            <div :class="'block1 trtagzz ' + tag.cls" v-for="(tag, j) in info.trainv.strs.tags" :key="j">


              <img class="incoimg" v-if="tag.icon" :src="tag.icon" /> <span> {{ tag.tit }}</span>

            </div>



          </div>
          <div class="lef btf_soll">
            <div class="ponts">
              <div class="bl " v-for="(pt, n) in info.trainv.strs.start_points" :key="pt.title"
                @click="show_point(pt.id)">
                {{ pt.title }} <br>
                {{ pt.time }}
              </div>
              <div class="bl yel " v-for="(pt, n) in info.trainv.strs.end_points" :key="pt.title"
                @click="show_point(pt.id)">
                {{ pt.title }}
                <br>
                {{ pt.time }}
              </div>
            </div>
          </div>
        </div>

        <div class="confirm_info">
          <div class="y3">
            <div class="cc">
              <div class="tit4">
                <span>{{ $lang(42348)}}</span>
              </div>
              <div class="con1">
                <span> {{order.date}}</span>
              </div>
            </div>
            <div class="cc">
              <div class="tit4">
                <span></span>
              </div>
              <div class="con1">
                <span></span>
              </div>
            </div>
          </div>
          <div class="y3">
            <div class="cc">
              <div class="tit4">
                <span>{{ $lang(42349)}}</span>
              </div>
              <block v-for="(pt, n) in info.trainv.strs.start_points" :key="n">


                <div class="con1" v-if="order.start_point_id == pt.id">
                  <span>
                    {{ pt.title}} {{ pt.time }}
                  </span>
                </div>
              </block>
            </div>
            <div class="cc">
              <div class="tit4">
                <span>{{ $lang(42350)}}</span>
              </div>
              <block v-for="(pt, n) in info.trainv.strs.end_points" :key="n">
                <div class="con1" v-if="order.end_point_id == pt.id">
                  <span>
                    {{ pt.title}} {{ pt.time }}
                  </span>
                </div>
              </block>
            </div>
          </div>
          <div class="y3">
            <div class="cc">
              <div class="tit4">
                <span>{{ $lang(42351)}} ({{ $lang(42352)}})</span>
              </div>
              <div class="con1">
                <span>{{ order.adult_num }} </span>
              </div>
            </div>
            <div class="cc">
              <div class="tit4">
                <span> {{ $lang(42351)}} ({{ $lang(42353)}}) </span>
              </div>
              <div class="con1">
                <span>{{ order.children_num }} </span>
              </div>
            </div>
          </div>
          <div v-for="(itm, i) in contacts" :key="i">
            <div class="y3">
              <div class="cc  ">
                <div class="tit4 ">
                  <span> {{ $lang(42357)}} ({{ $lang(42351)}} {{i+1}})</span>
                </div>
                <div class="con1  ">
                  <span>{{itm.name}}</span>
                </div>
              </div>
              <div class="cc  ">
                <div class="tit4  ">
                  <span>{{ $lang(42356)}} </span>
                </div>
                <div class="con1  ">
                  <span>{{itm.strs.sex}}</span>
                </div>
              </div>
            </div>
            <div class="y3 noboder">
              <div class="cc">
                <div class="tit4">
                  <span> {{ $lang(42360)}} </span>
                </div>
                <div class="con1">
                  <span> {{itm.age}} {{ $lang(42361)}} </span>
                </div>
              </div>

              <div class="cc">
                <div class="tit4">
                  <span> {{ $lang(42493) }}</span>
                </div>
                <div class="con1">
                  <span class="color_red"> {{itm.price}} {{ $lang(42374) }} </span>
                </div>
              </div>

            </div>
          </div>

          <div class="y3">
            <div class="cc">
              <div class="tit4">
                <span> {{ $lang(42364)}} </span>
              </div>
              <div class="con1">
                <span> {{order.tel}} </span>
              </div>
            </div>
            <div class="cc">
              <div class="tit4">
                <span>{{ $lang(42366)}}</span>
              </div>
              <div class="con1">
                <span> {{order.mail}} </span>
              </div>
            </div>
          </div>
          <div class="y3">
            <div class="cc">
              <div class="tit4">
                <span>{{ $lang(42368)}}</span>
              </div>
              <div class="con1">
                <span>{{ order.wx_num }} </span>
              </div>
            </div>
            <div class="cc">
              <div class="tit4">
                <span></span>
              </div>
              <div class="con1">
                <span></span>
              </div>
            </div>
          </div>
          <div class="y3">
            <div class="cc">
              <div class="tit4">
                <span> {{ $lang(42371)}} </span>
              </div>
              <div class="con1">
                <span> {{ order.amount }} {{ $lang(42374)}} </span>
              </div>
            </div>
            <div class="cc">
              <div class="tit4">
                <span></span>
              </div>
              <div class="con1">
                <span></span>
              </div>
            </div>
          </div>

        </div>
        <div class="pay_method">
          <div class="tit5">
            <span>{{ $lang(50045)}}</span>

          </div>
          <div class="topad">
            <el-select v-model="coupon_i" placeholder="" @change="coupon_change">
              <el-option v-for="(item, i) in coupon_list" :key="i" :label="item.coupon.strs.tit" :value="i">
              </el-option>
            </el-select>

            <el-input class="ipt" v-model="coupon_sn" :placeholder="$lang(50046)"></el-input>
            <el-button type="success" @click="get_coupon" icon="el-icon-check" circle></el-button>
          </div>
        </div>
        <div class="pay_method">

          <div class="tit5">
            <span>{{ $lang(42429)}}</span>
            <span class="color_red" style="font-size:20px;"> {{order.amount - coupon_amount}} {{ $lang(42374) }}</span>
          </div>
          <div class="pay">
            <div class="method">

              <el-radio class="radio1" v-model="radio" label="wxpay">
                <div class="bg_pay">
                  <div class="p1">
                    <img class="imgg" src="~@/../static/image/wx.png" alt="">
                  </div>
                  <div class="p1">
                    <span> {{ $lang(42428)}} </span>
                  </div>
                </div>
              </el-radio>
              <el-radio class="radio1" v-model="radio" label="alipay">
                <div class="bg_pay">
                  <div class="p1">




                    <img class="imgg" src="~@/../static/image/ali.png" alt="">
                  </div>
                  <div class="p1">
                    <span>{{ $lang(42426)}}</span>
                  </div>
                </div>
              </el-radio>
              <el-radio class="radio1" v-model="radio" label="pp" :disabled="true">
                <div class="bg_pay">
                  <div class="p1">
                    <img class="imgg" src="~@/../static/image/ppa.png" alt="">
                  </div>
                  <div class="p1">
                    <span>{{ $lang(42427)}}</span>
                  </div>
                </div>
              </el-radio>
            </div>
          </div>
        </div>

        <div class="up_down">
          <div class="btn" @click="back()">
            <span> {{ $lang(42372)}}</span>
          </div>
          <div class="btn" @click="pay()">
            <span> {{ $lang(42373)}}</span>
          </div>
        </div>
      </div>
    </div>

    <point_tc ref="pot_tc"> </point_tc>

    <el-dialog :title="$lang(42428)" :visible.sync="pay_show" @close="cleartime">
      <div class="tcwx">
        <div class="qrcode" ref="qrCodeUrl"></div>
        <div class="qrtxt">
          <i class="el-icon-info"></i>
          <br />
          {{$lang(51061)}}
          <br />
          {{ $lang(55077)}}
        </div>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import nav_list from './nav_list.vue';
import QRCode from 'qrcodejs2'
export default {
 name: "confirm_info",
  components: {  //注册
    nav_list,
  },
  data() {
    return {
      pay_show : false,
      info: {},
      sn : '',
      msg: "",
      radio:'wxpay',
      name:'',
      order: {},
      contacts : [],
      cp_info: '',
      thumb: '',
      refund_plan: '',
      coupon_sn: '',
      coupon_list : [],
      coupon_id : -1,
      coupon_i : '',
      coupon_amount : 0,
      timer  : '',
    };

  },
  mounted(e) {
    if (!this.$route.query.sn) {
      return this.jump('/')
    }
    this.sn = this.$route.query.sn
    document.title = this.web_tit;
    this.f5()
    // this.createQrcode()
  },
  methods: {
    createQrcode(txt) {

      this.$refs.qrCodeUrl.innerHTML = ""//词句代码将之前的二维码清空了

      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: txt,
        width: 260,
        height: 260,
        colorLight: '#000',
        colorDark: '#fff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    show_point(id) {

      this.$refs.pot_tc.f5(id)
    },
    coupon_change(e) {
      this.coupon_id = this.coupon_list[e].id
      	if (this.coupon_list[e].coupon.type == 0) {
					this.coupon_amount = this.coupon_list[e].coupon.strs.reduce
				} else {
					this.coupon_amount = this.order.amount * this.coupon_list[e].coupon.reduce / 100
				}


    },
    f5() {
      let ths = this
      this.get("/train/order_info", { sn: this.sn }).then((e) => {
        this.info = e.info
        this.order = e.order
        this.contacts = e.contacts
        this.cp_info = e.cp_info
        this.thumb = e.thumb
        this.refund_plan = e.refund_plan
        this.coupon_list = e.coupon_list
        if (e.order.status == 4) {
          this.$alert(this.$lang(55078), {
            confirmButtonText: 'OK',
            callback: action => {
              ths.jump('/bus_list')
            }
          });
        }

        if (e.order.status != 0) {
          this.$alert(this.$lang(55079), {
            confirmButtonText: 'OK',
            callback: action => {
              ths.jump('/bus_list')
            }
          });
        }

      });
    },
    get_coupon() {
      if (!this.coupon_sn) {
        return
      }
      this.get("/user/get_coupon", { sn: this.coupon_sn }).then((e) => {

        this.f5()


      });
    },
    cleartime() {
      clearInterval(this.timer)
    },
    check_pay_status(){
      if (this.pay_show) {
        console.log(this.order.sn)
        this.get("/train/check_pay?sn=" + this.sn, { }, 'GET', false).then((e) => {


            if (e.status == 1) {
              this.cleartime()
              this.pay_show = false
              this.$message({
                type: 'success',
                message: this.$lang(42628)
              });
              this.jump('/bus_list', {}, true)
            }
            if (e.status == 4) {

              this.$alert(this.$lang(55078), {
                confirmButtonText: 'OK',
                callback: action => {
                  this.jump('/bus_list')
                }
              });
            }


        });
      }
    },
    pay() {
      let ths = this
      this.get("/train/pay", { sn: this.sn, coupon_id: this.coupon_id, pay_type : this.radio }).then((e) => {
        if (e.s == 0) {
          this.$alert(this.$lang(55078), {
            confirmButtonText: 'OK',
            callback: action => {
              ths.jump('/bus_list')
            }
          });
          return
        }

        if (e.s == 1) {
          this.$alert(this.$lang(55079), {
            confirmButtonText: 'OK',
            callback: action => {
              ths.jump('/bus_list')
            }
          });
          return
        }
        if (this.radio == 'wxpay') {
          this.pay_show = true
          setTimeout(() => {
            this.createQrcode(e.code)
          }, 200);
          this.timer = setInterval(() => {
            ths.check_pay_status()
          }, 1000)
        }

        if (this.radio == 'alipay') {
          window.location.href = this.admin_url + '/alipay?sn=' + this.sn
        }

        return
        if (e.token) {

          this.cache('info', e.info);
          this.cache('token', e.token);

        }

        // this.$message({
        //   type: 'success',
        //   message: this.$lang(42628)
        // });
        // this.jump('/bus_list', {}, true)



      });
    },
  }

}
</script>

<style scoped>
.tcwx {
  width: 100%;
  text-align: center;
}

.tcqrcode {
  margin: auto;
}

.qrcode {
  margin: auto;
  width: 260px;
}
.qrtxt {
  color: green;
  font-size: 20px;
  line-height: 30px;
}

 .ponts {
   display: flex;
   align-items: center;
   width: 100%;
   text-align: center;
   font-weight: bold;
 }

 .bl {
   padding: 10px 10px;
   box-sizing: border-box;
   background: #E8F3FF;
   border-radius: 5px;
   color: #175EFF;
   margin-right: 10px;
   font-size: 14px;

 }

 .yel {

   background: #FFF7E9;
   color: #FE7D00;
 }

.per{
    display: flex;
    margin-top: 2%;
}
/* 详细信息 */
.t1{
    margin-left: 14%;
    width: 330px;
    height: 85vh;
    box-sizing: border-box;
    background: rgb(255, 255, 255);
    border: 1px solid rgba(108, 117, 125, 0.1);
    border-radius: 10px;
}
.t1 .tit1{
      width: 100%;
        height: 56px;
        line-height: 56px;
        background: rgb(4, 100, 221);
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        text-align: center;
        color: rgb(255, 255, 255);
        font-family: Noto Sans SC;
        font-size: 18px;
        font-weight: 400;
}
.t1 .tit1 .info{
    display: flex;
    margin: 0 auto;
    width: 72px;
    color: rgb(255, 255, 255);
    font-family: Noto Sans SC;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0%;
}
.t1 .tit1 .info span{
    margin-top: 19%;
}
.t1 .img1 img{
    width: 330px;
    height: 191px;
}
.t1 .img1 img{
    width: 330px;
    height: 191px;
}
.t1 .train  {
    display: flex;
    width: 100%;
    margin-bottom: 3%;
}
.t1 .train .tit2 {
    margin-right: 4%;
    margin-left:6%;
    margin-top:2%;
    color: rgb(4, 100, 221);
    font-family: Noto Sans SC;
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;
    letter-spacing: 0%;
    text-align: center;
}
.t1 .train .con1 {
    margin-right: 2%;
    margin-top:2%;
    color: rgb(33, 37, 41);
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 0%;
}
.t1 .txt1 {
    margin-bottom: 3%;
    width: 100%;
    background: rgb(255, 250, 250);
    border-radius: 10px;
}
.t1 .txt1 .text1{
    margin-left: 6%;
    margin-right: 6%;
    margin-top: 3%;
    margin-bottom: 3%;
    color: rgb(108, 117, 125);
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0%;
    text-align: left;
}.t2 {
  display: flex;
  flex-direction: column;
  margin-left: 2%;
}

.t2 .step1 {
  width: 58vw;
  height: 14vh;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 1px solid rgba(108, 117, 125, 0.1);
  border-radius: 10px;
  display: flex;
}

.t2 .step1 .con1 {
  flex: 0 0 33%;
  display: flex;
}

.t2 .step1 .con1 img {
  margin-left: 15%;
  margin-right: 5%;
  margin-top: 12%;
  width: 30px;
  height: 30px;
}

.t2 .step1 .con1 .y1 {
  margin-top: 12%;
}

.t2 .step1 .con1 .y1 .u1 {
  color: rgb(29, 33, 41);
  font-family: Noto Sans SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: left;
  font-weight: bold;
}

.t2 .step1 .con1 .y1 .u2 {
  color: rgb(134, 144, 156);
  font-family: Noto Sans SC;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: left;
}.t2 .channel {
  margin-top: 1%;
  display: flex;
  flex-direction: column;
  width: 58vw;
  min-height: 25vh;
    box-sizing: border-box;
    padding: 20px 0px;

  background: rgb(255, 255, 255);
  border: 1px solid rgba(108, 117, 125, 0.1);
  border-radius: 10px;
}

.t2 .screen {
  margin-top: 2%;
  display: flex;
}

.t2 .channel .screen .block1 {
  background-color: rgb(249, 250, 254);
  color: #000;
  margin-left: 2%;

  height: 35px;
  line-height: 30px;

  display: flex;
  border-radius: 4px;
  padding: 0 10px;
  border-radius: 5px;
  background-color: rgba(239, 239, 239, 1);
  color: #6C6C6C;
  text-align: center;
}
.t2 .channel .screen .block1 .y2{
    margin: 0 auto;
}
.t2 .channel .screen .block1 img{
    width: 18px;
    height: 18px;

}
.t2 .channel .screen .block1 span {

  font-family: Noto Sans SC;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0%;
}
.t2 .channel .lef{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 3%;
    margin-left: 2%;
}
.t2 .channel  .lef .lis_tab{
    text-align: center;
}
.t2 .channel  .lef .lis_tab .tit3{
    color: rgb(4, 100, 221);
}

.t2 .confirm_info{
    margin-top: 1%;
    width: 58vw;

    box-sizing: border-box;
    background: rgb(255, 255, 255);
    border: 1px solid rgba(108, 117, 125, 0.1);
    border-radius: 10px;
    padding: 3%;

}
.t2 .confirm_info .y3{
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border-top: 1px solid rgb(229, 230, 235);
      border-bottom: 1px solid rgb(229, 230, 235);

}
.t2 .confirm_info .y3 .cc{
     display: flex;
}
.t2 .confirm_info   .noboder{
  /* border: none !important;
  border-bottom: none !important;
  border-top: none !important; */
  border-bottom: 1px solid rgb(176, 176, 176);

}
.t2 .confirm_info .y3 .cc .tit4{
    width: 9.5vw;
    background: rgb(242, 246, 250);
    display: flex;
    min-height: 60px;
}
.color_red {
  color: red !important;
}
.t2 .confirm_info .y3 .cc .tit4 span{
    margin-left:15%;
    margin-top:11.5%;
    color: rgb(66, 84, 134);
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0%;

}
.t2 .confirm_info .y3 .cc .con1 {
    width: 17vw;
    display: flex;
    min-height: 60px;
}
.t2 .confirm_info .y3 .cc .con1 span{
    margin-left:15%;
    margin-top:6%;
    color: rgb(108, 117, 125);
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 0%;

}
.t2 .coupon {
      margin-top: 1%;
        width: 58vw;
        min-height: 15vh;
        padding: 20px 0px;
        box-sizing: border-box;
        background: rgb(255, 255, 255);
        border: 1px solid rgba(108, 117, 125, 0.1);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
}
 .t2 .topad {

  margin-left: 1%;
  margin-top: 1%;

  box-sizing: border-box;
  background: rgb(255, 255, 255);
  /* border: 1px solid rgba(108, 117, 125, 0.1); */
  border-radius: 10px;
  padding-right: 70px;
  display: flex;
  flex-direction: row;
  justify-content: end;
}

 .t2 .topad .ipt {
  width: 40%;
  margin-right: 2%;
  margin-left: 2%;
}

.t2 .pay_method {
    margin-top: 1%;
    width: 58vw;
    min-height: 15vh;
      padding: 20px 0px;
    box-sizing: border-box;
    background: rgb(255, 255, 255);
    border: 1px solid rgba(108, 117, 125, 0.1);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
}
.t2 .pay_method .tit5 {
    margin-top: 2%;
    margin-left: 3%;
    width: 90%;
    display: flex;
    justify-content: space-between;
}
.t2 .pay_method .tit5 span{
    color: rgb(66, 84, 134);
    font-family: Noto Sans SC;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 0%;
    text-align: center;
    display: block;
}
.t2 .pay_method .method{
    width: 100%;
    display: flex;
}
.t2 .radio1{
    margin-left: 3%;
    margin-top: 3%;
    flex:  0 0 30%;
    display: flex;
      margin-right: 1em;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
  transition: all 250ms ease;
  align-items: center;
}
.t2 .radio1 .bg_pay{
    width: 11.5vw;
    box-sizing: border-box;
    border: 1px solid rgba(108, 117, 125, 0.1);
    border-radius: 4px;
    display: flex;
    align-items: center;
    height: 48px;
}
.t2   .bg_pay .p1{

    flex: 0 0 40%;
}

.imgg {

   width: 25px;
   height: 25px;
}


.t2 .up_down  {
    width: 58vw;
    display: flex;
}
.t2 .up_down .btn{
    margin: 0 auto;
    margin-top: 3%;
    margin-bottom: 4%;
    width: 180px;
    height: 48px;
    background: rgb(255, 121, 0);
    border-radius: 2px;
    display: flex;
}
.t2 .up_down  .btn span{
    margin: 0 auto;
    color: rgb(255, 255, 255);
    font-family: Noto Sans SC;
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    letter-spacing: 0%;
    margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/confirm_info.vue